import { render, staticRenderFns } from "./TagUserField.vue?vue&type=template&id=44460089&"
import script from "./TagUserField.vue?vue&type=script&lang=js&"
export * from "./TagUserField.vue?vue&type=script&lang=js&"
import style0 from "./TagUserField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VIcon,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44460089')) {
      api.createRecord('44460089', component.options)
    } else {
      api.reload('44460089', component.options)
    }
    module.hot.accept("./TagUserField.vue?vue&type=template&id=44460089&", function () {
      api.rerender('44460089', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/deliverable/TagUserField.vue"
export default component.exports